import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { FieldConfig, FieldDictionaryDto, GridInfo, listResponseModel, SingleResponseModel } from '../../models/base/base';
import { HttpClient } from '@angular/common/http';
import { BaseHttpService } from '../base/base-http.service';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from '../base/base.service';
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { RTL } from 'src/app/@theme/const';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { UserMenuService } from '../user/user-menu.service';
import { SessionWrapperService } from '../session/session-wrapper.service';


@Injectable({
  providedIn: 'root'
})
export class FieldsConfigService<T> extends BaseHttpService<FieldDictionaryDto> implements OnInit, OnDestroy {
  private url = environment.baseUrl + this.getResourceUrl();
  systemmenuid: string = '';
  datadictionary: FieldDictionaryDto[];

  fieldConfigSubject = new BehaviorSubject<FieldDictionaryDto[] | any>(null);
  fieldConfig = this.fieldConfigSubject.asObservable();

  gridInfoSubject = new Subject<GridInfo[] | any>();
  displayListSubject = new Subject<FieldDictionaryDto[] | any>();

  private infoColumnsSubject = new BehaviorSubject<FieldDictionaryDto[] | any>(null);
  infoColumns = this.infoColumnsSubject.asObservable();

  private filterColumnsSubject = new BehaviorSubject<FieldDictionaryDto[] | any>(null);
  filterColumns = this.filterColumnsSubject.asObservable();

  printColumnsSubject = new Subject<string[] | any>();
  currentlang;
  pageparameters;

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private httpClient: HttpClient,
    private baseService: BaseService,
    private themeLayout: ThemeLayoutService,
    private translate: TranslateService,
    private userMenuService: UserMenuService,
    private sessionService: SessionWrapperService
  ) {
    super(httpClient);
    this.currentlang = this.baseService.getCurrentLanguage();
    // this.getData();

    this.themeLayout.directionChange.pipe(takeUntil(this.destroy$)).subscribe({
      next: (dir) =>{
        (dir == RTL) ? this.currentlang = 'ar' : this.currentlang = 'en';
        // this.getGridInfo();
        if(this.systemmenuid) this.getData();
      }
    });
  }

  ngOnInit(): void {
    if(this.systemmenuid) this.getData();
    this.pageparameters = this.sessionService.getPageParameter();
  }

  getResourceUrl(): string {
    return 'FieldDictionary';
  }

  setMenuId(menuid) {
    this.systemmenuid = menuid;
  }

  getAllData(): Promise<any> {
    let lang = this.currentlang == 'ar' ? 'ar-EG' : this.currentlang;
    // https://host.tabmshr.com/api/v1/FieldDictionary/GetBySystemMenuIDAndLanguage?TABSystemMenuId=561b87e0-dd18-4731-a740-cc3768611cdc&langName=en
    let params = { menuid: this.systemmenuid, lang: lang, checkparameter: this.pageparameters };
    return this.httpClient.get(`${this.url}/GetFieldDictionaryByMenu`, { params: params }).toPromise();
  }
  getPageData(pageid: string) {
    // let lang = this.currentlang == 'ar' ? 'ar-EG' : this.currentlang;
    let params = { menuid: pageid};
    return this.httpClient.get<listResponseModel<FieldDictionaryDto>>(`${this.url}/GetFieldDictionaryByMenu`, { params: params });
  }

  getData() {
    this.getAllData().then(
      (res) => {
        // console.log('datadictionary', res)
        // let data = res.result?.filter((x) => x.tabSystemMenuId == this.systemmenuid);
        let data = res.result;
        // console.log('field dictionary data', data);
        this.datadictionary = data;
        // this.getGridInfo();
        // this.getDisplayColumns();
        this.getInfoData();
        this.getFilterData();
        this.getPrintableData();
        this.fieldConfigSubject.next(data);
      },
      (err) => {
        this.fieldConfigSubject.next(null);
      }
    );
  }

  // getGridInfo() {
  //   let displayData: FieldDictionaryDto[] = this.datadictionary?.filter((x) => x.displayList == true);
  //   // console.log('displayData', displayData);
  //   let gridInfo: GridInfo[] = [];
  //   if (displayData && displayData.length > 0) {
  //     gridInfo.push({ columnDef: 'select', header: 'select', cell: '', fieldType: '' });
  //     displayData.forEach((row: FieldDictionaryDto) => {
  //       console.log('row', row)
  //       gridInfo.push({
  //         columnDef: row.fieldName,
  //         // header: this.fieldData?.langValue[0].culutureValue,
  //         header: row.langValue[0].value,
  //         cell: (element: T) => `${row.fieldName}`,
  //         fieldType: row.fieldType
  //       });
  //     });
  //     gridInfo.push({ columnDef: 'action', header: 'action', cell: '', fieldType: '' });
  //   }
  //   //return gridInfo;
  //   this.gridInfoSubject.next(gridInfo);
  // }

  getDisplayColumns() {
    this.displayListSubject.next(this.getColumns('displayList'));
  }

  getFilterData() {
    this.filterColumnsSubject.next(this.getColumns('filter'));
  }

  //getCriteriaData() { return this.getColumns('criteria'); }

  isRequired(fieldname) {
    return this.checkField(fieldname, 'required');
  }

  getMinVal(fieldname) {
    return this.checkField(fieldname, 'minvalue');
  }

  getMaxVal(fieldname) {
    return this.checkField(fieldname, 'maxvalue');
  }

  getDefaultVal(fieldname) {
    return this.checkField(fieldname, 'defaultvalue');
  }

  getPrintableData() {
    let printHeaders = this.getColumns('printable');
    this.printColumnsSubject.next(printHeaders);
  }

  getInfoData() {
    this.infoColumnsSubject.next(this.getColumns('infofield'));
  }

  getColumns(condition) {
    return this.datadictionary?.filter((x) => x[condition] == true);
  }

  checkField(fieldname, condition) {
    let fieldsData = this.fieldConfigSubject.value;
    let value = fieldsData?.filter((x) => x.fieldname == fieldname).map((x) => x[condition]);
    return value == null ? null : value[0];
  }

  getFieldType(fieldname) {
    return this.checkField(fieldname, 'fieldType');
  }

  updateFieldDictionary(id: any, data: FieldDictionaryDto): Observable<SingleResponseModel<FieldDictionaryDto>> {
    return this.httpClient.post<SingleResponseModel<FieldDictionaryDto>>(`${this.url}/UpdateFieldDictionary?id=` + id, data);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
